export const SYMBOL_MAX_CHARACTER_COUNT = 256;
export const FIELD_TYPE_SYMBOL = 'Symbol';
export const TRANSLATION_KEY_SPLITTER = '__';
export const TRANSLATION_TAG_PREFIX = 'translation_';
export const BATCH_SIZE = 5;
export const THROTTLE_AMOUNT = 1;
export const THROTTLE_TIME = 1000;
